// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".files[data-v-50fd53a3] {\n  white-space: nowrap;\n  color: #0066ff;\n  cursor: pointer;\n}\n@media (min-width: 768px) {\n.cost[data-v-50fd53a3] {\n    text-align: right;\n}\n}\n", ""]);
// Exports
module.exports = exports;
